/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ValidationIssue } from './ValidationIssue';

export type RenderTableValidationIssue = {
    component_type: RenderTableValidationIssue.component_type;
    component_id?: (string | null);
    expression: string;
    issues?: Array<ValidationIssue>;
};

export namespace RenderTableValidationIssue {

    export enum component_type {
        ATTRIBUTE = 'attribute',
        FILTER = 'filter',
        GROUP = 'group',
        ORDER = 'order',
    }


}

